export default __webpack_public_path__ + "static/media/pasta.8b043e40.jpg";